import { render, staticRenderFns } from "./modifyMailbox.vue?vue&type=template&id=24c2b639&scoped=true&"
import script from "./modifyMailbox.vue?vue&type=script&lang=js&"
export * from "./modifyMailbox.vue?vue&type=script&lang=js&"
import style0 from "./modifyMailbox.vue?vue&type=style&index=0&id=24c2b639&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2b639",
  null
  
)

export default component.exports